import React, { useState } from 'react'
import { connect } from 'react-redux'
import { getFormValues, Field, reduxForm, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Confirm, Modal } from 'semantic-ui-react'
import { lower } from 'change-case'
import ReactTable from 'react-table'
import { validation, validateCase as vCase } from 'core/validate'
import { StdCard, MainBodyContent, CustomButton } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import Approvers from 'routes/ProcurementSystem/Shared/DocumentStep/Approvers'
import { billFormPath, goodsServiceReceiptDetailPath, purchaseOrderDetailPath, billCoverPath } from 'routes'
import { numberFormat, scrollToFirstValidateFailElement } from 'core/utilities'
import { showModal } from 'ducks/app'
import { BLContainer, RowFields, Cont, FooterCont, LinkInfo, BottomActionsContainer } from './styled'
import { clearBLDetail, getGRRelease, createBL, initializeBL, getBLGOAWorkFlowEditMode,
  filterInvoiceList, removeInvoiceItemList, addInvoiceItemList, resetInvoiceList,
  getGRReleaseDetail
} from 'ducks/billform'
import { acceptMessage, haveTypeGoods } from '../billingHelper'
// import r from 'reactotron-react-js'

const CreateBilling = props => {
  const {
    isCreate = true,
    isEdit = false,
    isDetail = false,
    change,
    history,
    userName,
    approvers,
    valueForm,
    GRRelease,
    GRSearchLoading,
    grReleaseDetail
  } = props

  const [actionName, setActionName] = React.useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState(0)
  const [currency, setCurrency] = useState('')
  const [firstSelect, setFirstSelect] = useState(true)
  const [ivSelected, setIVSelected] = useState([])
  const [tempSelect, setTempSelect] = useState([])
  const [showAcceptModal, setShowAcceptModal] = useState(false)
  const [companyPlant, setCompanyPlant] = useState('')
  const [blId, setBlId] = useState(0)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.initializeBL(isDetail)
    props.getGRRelease()
    return (() => {
      props.clearBLDetail()
    })
  }, [])

  React.useEffect(() => {
    if (ivSelected.length < 2) {
      props.getBLGOAWorkFlowEditMode({
        creater: userName,
        requester: valueForm ? valueForm.requesterUser : '',
        companyCode: ivSelected.length > 0 ? ivSelected[0].companyCode : '',
        vendorCode: ivSelected.length > 0 ? ivSelected[0].vendorCode : '',
        companyPlant: ivSelected.length > 0 ? companyPlant : ''
      })
    }
  }, [(valueForm && valueForm.requesterUser), ivSelected])

  React.useEffect(() => {
    if (ivSelected.length > 0) {
      let data = ivSelected[0]
      setCurrency(data.currencyCode)
      let total = ivSelected.reduce((sum, i) => sum + (i.totalInvoiceAmount || 0), 0)
      change('totalAmount', total)
      setTotalInvoiceAmount(total)
    }
  }, [ivSelected])

  React.useEffect(() => {
    if (valueForm && valueForm.searchGoodsServiceReceipt) {
      let sIVL = valueForm.searchGoodsServiceReceipt.length
      let tIVL = tempSelect.length
      if (sIVL !== tIVL) {
        if (sIVL > tIVL) {
          //set companyPlant
          let findSelectedInvoice = GRRelease.find(x=>x.id == valueForm.searchGoodsServiceReceipt[sIVL - 1])
          if(findSelectedInvoice) setCompanyPlant(findSelectedInvoice.companyPlant)
            
          console.log('searchGoodsServiceReceipt',valueForm.searchGoodsServiceReceipt)
          props.getGRReleaseDetail(valueForm.searchGoodsServiceReceipt[sIVL - 1])
          setTempSelect(JSON.parse(JSON.stringify(valueForm.searchGoodsServiceReceipt)))
        } else if (sIVL < tIVL) {
          if (sIVL === 0) {
            setUpIVSelected(null)
            setTempSelect([])
            setFirstSelect(true)
            // clear option to default
            props.resetInvoiceList()
          } else {
            let grIdDeleted = -1
            // find grId is deleted
            tempSelect.forEach((x, i) => {
              let index = valueForm.searchGoodsServiceReceipt.findIndex(y => y === x)
              if (index < 0) {
                grIdDeleted = x
              }
            })
            // delete from IVSelected
            setUpIVSelected(grIdDeleted, true)
            // delete from tempSelect
            let cloneTempSelect = JSON.parse(JSON.stringify(tempSelect))
            let indexTSDeleted = cloneTempSelect.findIndex(x => x === grIdDeleted)
            cloneTempSelect.splice(indexTSDeleted, 1)
            setTempSelect(cloneTempSelect)
          }
        }
      }
    }
  }, [valueForm && valueForm.searchGoodsServiceReceipt])

  React.useEffect(() => {
    if (grReleaseDetail) {
      if (valueForm.searchGoodsServiceReceipt.length > 0) {
        if (firstSelect) {
          setFirstSelect(false)
          props.filterInvoiceList(valueForm.searchGoodsServiceReceipt[0])
          setUpIVSelected(grReleaseDetail)
        } else {
          setUpIVSelected(grReleaseDetail)
        }
      }
    }
  }, [grReleaseDetail])

  const setUpIVSelected = (data, remove = false) => {
    if (remove) {
      let cloneIVSeleted = JSON.parse(JSON.stringify(ivSelected))
      let indexIVDeleted = cloneIVSeleted.findIndex(x => x.id === data)
      cloneIVSeleted.splice(indexIVDeleted, 1)
      setIVSelected(cloneIVSeleted)
    } else {
      if (data === null || data === undefined) {
        // clear select
        setIVSelected([])
      } else {
        let clone = JSON.parse(JSON.stringify(ivSelected))
        clone.push(data)
        setIVSelected(clone)
      }
    }
  }

  const validateField = (values, actionName = null) => {
    let errors = {}
    if (!values.title) {
      errors.title = 'Required!'
    }
    if (values.title && values.title.length > 200) {
      errors.title = 'Title must be less than or equal to 200 characters'
    }
    if (!values.requesterUser) {
      errors.requesterUser = 'Required!'
    }
    if (!values.searchGoodsServiceReceipt) {
      errors.searchGoodsServiceReceipt = 'Required!'
    }
    return errors
  }

  const onSubmitSuccess = (id) => {
    setBlId(id)
    setShowAcceptModal(true)
  }

  const Submit = () => {
    setShowConfirm(false)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
      .then(() => {
        let errors = validateField(valueForm)
        if (Object.keys(errors).length) {
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          let validateFile = true
          if (checkInternalCompany()) {
            validateFile = valueForm.BL04 && valueForm.BL04.length > 0 ? true : false
          }
          if (validateFile) {
            props.createBL(valueForm, history, actionName === 'submit', onSubmitSuccess)
          } else {
            props.showModal(
              true,
              'Please attach document!',
              <React.Fragment><ul><li>Invoice</li></ul></React.Fragment>
            )
          }
        }
      })
  }

  const renderCompanyInfo = () => {
    let data = ivSelected[0]
    if (data) {
      return (
        <Cont>
          <div className='title'>Company Information</div>
          <div className='rowI' >
            <div className='stBold'>{data.companyName}</div>
            <div className='stBold'>{`Tax Id : ${data.companyTaxId}`}</div>
          </div>
          <div>{`Address : ${data.companyAddress}`}</div>
          <div className='stBold'>Delivery Address</div>
          <div>{data.companyName}</div>
          <div>{data.companyAddress}</div>
        </Cont>
      )
    } else {
      return null
    }
  }

  const checkInternalCompany = () => {
    if (grReleaseDetail) {
      let vendorCodeCheck = grReleaseDetail.vendorCode.startsWith('9') || grReleaseDetail.vendorCode.startsWith('6')
      let deliveryTypeCheck = grReleaseDetail.mainDeliveryType && grReleaseDetail.mainDeliveryType.toLowerCase() === 'service'
      return vendorCodeCheck && deliveryTypeCheck
    } else {
      return false
    }
  }

  return (
    <MainBodyContent
      headerTitle='Billing - Create '
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(billFormPath)}
            icon='close'
            btnColor='red'
            title='Cancel'
          />
        </div>
      }
      breadcrumbs={
        <Breadcrumb
          icon='right angle'
          sections={[
            {
              key: 'BL',
              content: 'Billing',
              link: true,
              onClick: () => history.push(billFormPath),
            },
            { key: 'GREdit', content: 'Create', active: true },
          ]}
        />
      }
    >
      {/* <Button
        content='test accept modal'
        onClick={() => setShowAcceptModal(true)}
      /> */}
      <BLContainer>
        <StdCard title={<span className='stepTitle'>Step 1 : Title</span>}
          accessoriesHeader={
            (isCreate) &&
            <React.Fragment>
              <Approvers
                approvers={approvers.data}
                status={valueForm && valueForm.status}
                trigger={
                  <Button
                    basic
                    circular
                    type='button'
                    loading={approvers.loading}
                    content='View Approver'
                    labelPosition='right'
                    icon='sort numeric down' />
                }
              />
            </React.Fragment>
          }>
          <RowFields>
            <Field
              name='title'
              label='Title'
              require
              type={type.text}
              component={FieldInput}
              maxLength={200}
              maxLengthMessage='Title must be less than or equal to 200 characters'
            />
            <Field
              name='requesterUser'
              label='Requester'
              require
              editable={isCreate || isEdit}
              type={type.select}
              component={FieldInput}
              allowAdditions={false}
              loading={props.members.loading}
              options={props.members.map((x, i) => ({
                key: i, value: lower(x.username), text: `${x.firstnameEn} ${x.lastnameEn}`,
              }))}
            />
          </RowFields>
        </StdCard>
        <div style={{ marginTop: '1rem' }} />
        <StdCard title={<span className='stepTitle'>Step 2 : Choose Invoices</span>}>
          <RowFields>
            <Field
              name='searchGoodsServiceReceipt'
              label='Choose Invoices'
              placeHolder='Search Invoice No. , GR No.'
              require
              component={FieldInput}
              allowAdditions={false}
              loading={GRSearchLoading}
              options={GRRelease.map(x => ({
                value: x.id, text: `Invoice No. ${x.invoiceNumber}  | ${x.documentNumber}`
              }))}
              type={type.multiSelect}
            />
          </RowFields>
          {ivSelected.length > 0 ?
            <div style={{ maxWidth: '100%' }}>
              {renderCompanyInfo()}
            </div>
            : null
          }
          <br />
          {ivSelected.length > 0 ?
            <RowFields>
              <div style={{ width: '100%', paddingRight: '0.9357rem', }}>
                <ReactTable
                  data={ivSelected}
                  columns=
                  {[
                    {
                      Header: <div style={{ textAlign: 'start' }}>Invoice No.</div>,
                      id: 'ivNumber',
                      accessor: row => (row),
                      Cell: row => (
                        <LinkInfo onClick={() => window.open(goodsServiceReceiptDetailPath(row.value.id || row.value.grId))}>{row.value.invoiceNumber}</LinkInfo>
                      )
                    }, {
                      Header: 'Delivery Type',
                      accessor: 'mainDeliveryType',
                      className: 'center',
                      width: 100,
                    }, {
                      Header: 'InvoiceAmount',
                      accessor: 'totalInvoiceAmount',
                      className: 'right',
                      width: 100,
                      Cell: row => numberFormat(row.value, true),
                    }, {
                      Header: 'Currency',
                      accessor: 'currencyCode',
                      className: 'center',
                      width: 80,
                    }, {
                      Header: 'PO No.',
                      id: 'pos',
                      accessor: row => (row),
                      className: 'center',
                      Cell: row => {
                        return (
                          <div>
                            {row.value.pos.map((x, i) => (
                              <LinkInfo onClick={() => window.open(purchaseOrderDetailPath(x.id))}>{x.poSapNumber}</LinkInfo>
                            ))}
                          </div>)
                      },
                      width: 100,
                    }
                  ]}
                  resizable={false}
                  NoDataComponent={() => null}
                  minRows={valueForm && valueForm.searchGoodsServiceReceipt && valueForm.searchGoodsServiceReceipt.length > 10 ? 10 : valueForm.searchGoodsServiceReceipt.length || 5}
                  defaultPageSize={10}
                  showPagination={false}
                  className='-striped -highlight'
                />
                <FooterCont>
                  {valueForm && valueForm.searchGoodsServiceReceipt && valueForm.searchGoodsServiceReceipt.length > 0 &&
                    <div>
                      <div className='title'> {`Total (Inc.VAT)`} :</div>
                      <div className='value'>
                        <div className='amount'>{numberFormat((totalInvoiceAmount || 0), true)}</div>
                        <div className='right'>{currency} </div>
                      </div>
                    </div>
                  }
                </FooterCont>
              </div>
            </RowFields>
            : null
          }
          <br />
          <Field
            name='remark'
            label='Remark :'
            type={type.textArea}
            component={FieldInput}
          />
        </StdCard>
        <div style={{ height: '1rem' }} />
        <StdCard title={<span className='stepTitle'>Step 3 : Upload Files</span>} >
          <RowFields>
            {checkInternalCompany() ?
              <Field name='BL04' label='Invoice :' type={type.file} component={FieldInput} require /> : null}
            <Field name='BL01' label='Receipt :' type={type.file} component={FieldInput} />
            <Field name='BL02' label='Other documents :' type={type.file} component={FieldInput} />
          </RowFields>
        </StdCard>
      </BLContainer>
      <Confirm
        size='mini'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={props.handleSubmit(() => Submit())}
      />
      <form onSubmit={props.handleSubmit(() => Submit())}>
        <BottomActionsContainer >
          <Button
            type='button'
            content='Save'
            icon='save'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => {
              setActionName('save')
              setShowConfirm(true)
            }}
          />
          <Button
            type='button'
            content='Save & Submit'
            color='blue'
            icon='save'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => {
              setActionName('submit')
              setShowConfirm(true)
            }}
          />
        </BottomActionsContainer>
      </form>
      <Modal 
        open={showAcceptModal}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        {acceptMessage(ivSelected)}
        <Modal.Actions>
          <Button
            content='Accept'
            labelPosition='right'
            icon='checkmark'
            onClick={() => {
              setShowAcceptModal(false)
              if (haveTypeGoods(ivSelected || [])) {
                history.push(billCoverPath(blId))
              } else {
                history.push(billFormPath)
              }
            }}
          />
        </Modal.Actions>
      </Modal>
    </MainBodyContent>
  )
}

const validate = values => {
  let errors = {}
  errors = validation(values, 'title', [vCase.maxLength200], errors)
  errors = validation(values, 'invoiceNumber', [vCase.maxLength25], errors)

  return errors
}


const mapStateToProps = (state, props) => {
  let valueForm = getFormValues('formBL')(state) || {}
  const date = new Date()
  const userName = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  let requesterUser = userName ? lower(userName) : ''

  return {
    initialValues: {
      requesterUser: requesterUser,
      searchGoodsServiceReceipt: [],
      documentDate: valueForm.documentDate || new Date(date.getFullYear(), date.getMonth(), date.getDate()),
    },
    valueForm,
    userName,
    GRRelease: state.billform.GRSearch.data,
    GRSearchLoading: state.billform.GRSearch.loading,
    approvers: state.billform.approvers,
    grReleaseDetail: state.billform.grReleaseDetail,
    members: state.member.members
  }
}

const mapDispatchToProps = {
  initializeBL,
  clearBLDetail,
  getGRRelease,
  createBL,
  getBLGOAWorkFlowEditMode,
  filterInvoiceList,
  removeInvoiceItemList,
  addInvoiceItemList,
  resetInvoiceList,
  getGRReleaseDetail,
  showModal
}

const CreateBillingForm = reduxForm({
  form: 'formBL',
  enableReinitialize: true,
  validate
})(CreateBilling)

export default connect(mapStateToProps, mapDispatchToProps)(CreateBillingForm)
